import { render, staticRenderFns } from "./CreatorProjects.vue?vue&type=template&id=dea59070"
import script from "./CreatorProjects.vue?vue&type=script&lang=js"
export * from "./CreatorProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports